import React from "react";
const AlertCard = ({ color, header, title, description }) => {
  return (
    <div className="alert" style={{ backgroundColor: color }} role="alert">
      <h4 className="alert-heading">{header}</h4>
      <p>{title}</p>
      <hr />
      <p className="mb-0" style={{ fontSize: "18px" }}>
        {description}
      </p>
    </div>
  );
};

export default AlertCard;
